import {
    ADMIN_BUDGET,
    BUDGET,
    BUDGET_USER,
    DECISION,
    DECISION_USER,
    EXPLORE_USER,
    RAWDATA,
    ACCESS_DAF,
    SUPPORT,
    ADMIN,
    ADMIN_CATEGORIES,
    SUPER_FINANCES_WRITER,
    ACCESS_BUDGETS_GESTION,
    ACCESS_CADRAGE_GESTION,
} from 'business/constants';
import { ModuleTree, Permission } from '../types';

const adminBudgetPermissions: Permission[] = [
    {
        permissionName: ACCESS_DAF,
        visibleBy: [SUPPORT, ADMIN],
        isControlledByHeader: true,
        determinePermissionsDisplay: true,
    },
    {
        permissionName: SUPER_FINANCES_WRITER,
        visibleBy: [SUPPORT, ADMIN],
        isControlledByHeader: true,
        determinePermissionsDisplay: true,
    },
    {
        permissionName: ADMIN_CATEGORIES,
        visibleBy: [SUPPORT, ADMIN],
        isControlledByHeader: true,
        determinePermissionsDisplay: true,
    },
    {
        permissionName: ACCESS_CADRAGE_GESTION,
        visibleBy: [SUPPORT, ADMIN],
        isControlledByHeader: true,
        determinePermissionsDisplay: true,
    },
    {
        permissionName: ACCESS_BUDGETS_GESTION,
        visibleBy: [SUPPORT],
        isControlledByHeader: false,
        determinePermissionsDisplay: false,
    },
];

const defaultDecisionModuleWithSubRoles: ModuleTree = {
    name: DECISION,
    moduleRole: DECISION_USER,
    roles: [{ roleName: EXPLORE_USER }, { roleName: RAWDATA }],
};

const budgetModuleWithSubRoles: ModuleTree = {
    name: BUDGET,
    moduleRole: BUDGET_USER,
    roles: [
        {
            roleName: ADMIN_BUDGET,
            permissions: adminBudgetPermissions,
        },
    ],
};

export const modulesWithSubRoles: ModuleTree[] = [
    defaultDecisionModuleWithSubRoles,
    budgetModuleWithSubRoles,
];

export const modulesWithSubRolesWhenEssential: ModuleTree[] = [
    {
        ...defaultDecisionModuleWithSubRoles,
        roles: [{ roleName: RAWDATA }],
    },
    budgetModuleWithSubRoles,
];

export const MODULES_TRANSLATION_PATH =
    'adminSpace.createUser.modalStepper.generalSection.modulesSelection';
